import { Lot } from 'types';

export const getTotalLineItemCount = (lots?: Lot[]): number =>
  lots?.length
    ? lots.reduce((total, lot) => total + lot.line_items_count, 0)
    : 0;
